// src/components/RatingModal.js

import React, { useState } from 'react';

// A helper component to render the interactive stars
const StarRatingInput = ({ rating, setRating }) => {
    return (
        <div className="flex justify-center my-4">
            {[1, 2, 3, 4, 5].map((star) => (
                <svg
                    key={star}
                    onClick={() => setRating(star)}
                    onMouseOver={() => setRating(star)} // Allows for hover effect
                    className={`w-10 h-10 cursor-pointer ${rating >= star ? 'text-yellow-400' : 'text-gray-300'}`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
            ))}
        </div>
    );
};

export default function RatingModal({ onClose, onSubmit, userToRate }) {
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (rating === 0) {
            // Optionally, show an alert or message that rating is required
            alert("Por favor, selecione uma avaliação de 1 a 5 estrelas.");
            return;
        }
        // The onSubmit function will contain the Firestore logic
        onSubmit({ rating, comment });
    };

    return (
        // This is the modal backdrop
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            {/* This is the modal content panel */}
            <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-md mx-4">
                <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">Avaliar sua troca</h2>
                <p className="text-center text-gray-500 mb-6">Como foi sua experiência com {userToRate?.email || 'o outro usuário'}?</p>
                
                <form onSubmit={handleSubmit}>
                    <StarRatingInput rating={rating} setRating={setRating} />
                    
                    <div className="mt-4">
                        <label htmlFor="comment" className="block text-sm font-medium text-gray-700">Deixar um comentário (opcional):</label>
                        <textarea
                            id="comment"
                            rows="3"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500"
                            placeholder="Ex: Vendedor atencioso, produto conforme o descrito."
                        />
                    </div>

                    <div className="mt-8 flex justify-end space-x-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-6 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="px-6 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-lg hover:bg-green-700"
                        >
                            Enviar Avaliação
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

